import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Fragment, useState } from 'react';
import { formatCNPJ } from 'utils/formatDate';
import { formatPhoneWithAreaCode } from 'utils/formatters';
import { useStoreSelector } from 'v3/data/store';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import { setAllStoreList } from 'v3/data/store/stores/actions';
import { IStoresListItem } from 'v3/data/store/stores/types';
import * as api from 'v3/services/api';
import { SubtitleMediumBold } from 'v3/shared/typography/SubtitleMedium';
import { theme } from 'v3/styles/global-styles';
import {
  AlignClientInfo,
  AlignValues,
  BodyLine,
  EditIcon,
  HeaderLine,
  Line,
  MainContainer,
  SeeMoreContainer,
  SubtitleLine,
  TableRowName,
} from '../styles';
import { EditStoreNameAndGroupModal } from 'v3/shared/components/Modal/EditStoreNameAndGroupModal';
import { IEditStoreNameAndGroupData } from 'v3/shared/components/Modal/EditStoreNameAndGroupModal/types';

interface IMobileTable {
  storesList: IStoresListItem[];
  featureFlag?: Boolean;
}

export const StoresMobileTable: React.FC<IMobileTable> = ({ storesList, featureFlag }) => {
  const { count, items } = useStoreSelector((store) => store.store.stores);
  const [openModal, setOpenModal] = useState(false);
  const [selectedStore, setSelectedStore] = useState<IStoresListItem>();

  const handleOpenModal = (store: IStoresListItem) => {
    setSelectedStore(store);
    setOpenModal(true);
  };

  const handleSaveStoreNameAndGroup = async (newStoreNameAndGroup: IEditStoreNameAndGroupData) => {
    try {
      if (!selectedStore) return;

      await api.updateStoreNameAndGroup(selectedStore.storeUserId, { name: newStoreNameAndGroup.name, storeGroupId: newStoreNameAndGroup.storeGroupId });

      const updatedItems = items.map((store) =>
        store.storeUserId === selectedStore.storeUserId ? { ...store, name: newStoreNameAndGroup.name, storeGroupId: newStoreNameAndGroup.storeGroupId } : store,
      );

      setAllStoreList({
        items: updatedItems,
        count,
      });
      showSnackbar('Loja alterada com sucesso', 'success', true);
      setOpenModal(false);
    } catch (error) {
      showErrorDialog('Erro ao atualizar loja', error);
    }
  };
  return (
    <Fragment>
      {storesList.map((store, index) => (
        <MainContainer key={store.storeUserId}>
          <AlignValues>
            <HeaderLine>Nome</HeaderLine>
            <AlignClientInfo>
              <TableRowName>
                <BodyLine>{store.name}</BodyLine>
                <EditIcon
                  onClick={() => {
                    handleOpenModal(store);
                  }}
                />
              </TableRowName>
              <SubtitleLine>{formatCNPJ(store.cnpj)}</SubtitleLine>
            </AlignClientInfo>
          </AlignValues>

          {featureFlag && (
            <AlignValues>
              <HeaderLine>Grupo</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{store.storeGroup?.name ?? '-'}</BodyLine>
              </AlignClientInfo>
            </AlignValues>
          )}

          <AlignValues>
            <HeaderLine>Contato</HeaderLine>
            <AlignClientInfo>
              <BodyLine>{store.email}</BodyLine>
              <SubtitleLine>
                {store.phone?.areaCode && store.phone?.phoneNumber
                  ? formatPhoneWithAreaCode(store.phone.areaCode, store.phone.phoneNumber)
                  : null}
              </SubtitleLine>
            </AlignClientInfo>
          </AlignValues>

          <Line />
          <SeeMoreContainer>
            <SubtitleMediumBold color={theme.palette.details.light}>Ver informações da loja</SubtitleMediumBold>
            <ArrowForwardIosIcon />
          </SeeMoreContainer>
        </MainContainer>
      ))}

{selectedStore && (
  <EditStoreNameAndGroupModal
    title="Editar loja"
    active={openModal}
    onClose={() => setOpenModal(false)}
    onSave={handleSaveStoreNameAndGroup}
    currentStore={selectedStore}
  />
)}
    </Fragment>
  );
};
